/** @file Looks up the mutable record of one entity inside a command's document draft. */
import type { Draft } from 'immer';
import type { Doc, EntityKind, Id } from '@pose2d/format/types';
import { ENTITY_KINDS } from '@pose2d/format/doc/entityKinds';
import { throwError } from '@pose2d/format/throwError';

/** The draft record of `id` in the table of `kind`, as a plain field map; NOT_FOUND when it is missing. */
export function entityDraft(draft: Draft<Doc>, kind: EntityKind, id: Id): Record<string, unknown> {
  const table = draft[ENTITY_KINDS[kind]] as Record<Id, Record<string, unknown> | undefined>;
  return table[id] ?? throwError('NOT_FOUND', { kind, ref: id });
}
